import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "audience-selector-item__name" };
const _hoisted_2 = { class: "audience-selector-item__stats" };
import { useAudienceStats } from "src/shared/store/audience/composables";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceSelectorItem',
    props: {
        isSelected: { type: Boolean },
        audience: {},
        isReadonly: { type: Boolean },
        isMultiple: { type: Boolean }
    },
    emits: ["toggleSelection"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const statsResult = useAudienceStats(props.audience.id);
        const emit = __emit;
        const toggleSelection = () => {
            if (props.isReadonly) {
                return;
            }
            emit("toggleSelection", props.audience.id);
        };
        const className = computed(() => ({
            "audience-selector-item--selected": props.isSelected,
            "audience-selector-item--readonly": props.isReadonly,
            "audience-selector-item--multiple": props.isMultiple,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["audience-selector-item", className.value]),
                onClick: toggleSelection
            }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.audience.name), 1 /* TEXT */),
                _createElementVNode("small", _hoisted_2, "Members: " + _toDisplayString(_unref(statsResult).results), 1 /* TEXT */)
            ], 2 /* CLASS */));
        };
    }
});
